import { createFrontendModule, SubPageBlueprint } from '@backstage/frontend-plugin-api';
import nativeNotificationsPlugin from '@backstage/plugin-notifications/alpha';

// Keeps the notifications page opt-in per user, as with the legacy FeatureFlagged route.
export const nfsNotificationsPlugin = nativeNotificationsPlugin.withOverrides({
  extensions: [
    nativeNotificationsPlugin
      .getExtension('page:notifications')
      .override({ if: { featureFlags: { $contains: 'notifications' } } }),
  ],
});

const notificationSettingsSubPage = SubPageBlueprint.make({
  name: 'notifications',
  attachTo: { id: 'page:user-settings', input: 'pages' },
  params: {
    path: 'notifications',
    title: 'Notifications',
    loader: () =>
      import('@backstage/plugin-notifications').then(m => (
        <m.UserNotificationSettingsCard originNames={{ 'plugin:scaffolder': 'Scaffolder' }} />
      )),
  },
});

export const notificationSettingsModule = createFrontendModule({
  pluginId: 'user-settings',
  extensions: [notificationSettingsSubPage],
});
